var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlueUnderlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33325 4.66671H8.66659V6.00004H7.33325V4.66671ZM7.33325 7.33337H8.66659V11.3334H7.33325V7.33337ZM7.99992 1.33337C4.31992 1.33337 1.33325 4.32004 1.33325 8.00004C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00004C14.6666 4.32004 11.6799 1.33337 7.99992 1.33337ZM7.99992 13.3334C5.05992 13.3334 2.66659 10.94 2.66659 8.00004C2.66659 5.06004 5.05992 2.66671 7.99992 2.66671C10.9399 2.66671 13.3333 5.06004 13.3333 8.00004C13.3333 10.94 10.9399 13.3334 7.99992 13.3334Z",
    fill: "#74C3E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlueUnderlined);
export default __webpack_public_path__ + "static/media/info-blue-underlined.ce2c7bbb955a6a7c84a3e1798c99a2cc.svg";
export { ForwardRef as ReactComponent };